import { useCallback, useState } from 'react';
import { useQuery } from 'react-query';
import { useContext } from 'react';
import { baseApiUrl, fetcher, ServerErrorResponse } from 'data_sources/constants';
import { AppContext } from 'views/App/context';
import { WrittenDirective } from '../../../_types/awb';

export const fetchWrittenDirectives = async (
  orgId: string,
  accreditationBodyId: string,
  versionId: string,
  standardId: string,
  jurisdictionId: string,
  useRUIData = false
) => {
  // Use non-org-specific API when awbRUIData feature is enabled
  const url = useRUIData
    ? `${baseApiUrl()}/awb/accreditation-body/v1/accreditation-bodies/${accreditationBodyId}/versions/${versionId}/standards/${standardId}/jurisdiction/${jurisdictionId}/written-directives`
    : `${baseApiUrl()}/awb/accreditation-body/v1/organizations/${orgId}/accreditation-bodies/${accreditationBodyId}/versions/${versionId}/standards/${standardId}/written-directives`;

  const data = await fetcher({
    method: 'get',
    url,
  });
  return data;
};

export default function useWrittenDirectives(
  orgId: string,
  accreditationBodyId: string,
  versionId: string,
  standardId: string,
  jurisdictionId: string,
  options = {},
  onError?: (errors: ServerErrorResponse) => void
) {
  const { isFeatureEnabled } = useContext(AppContext);
  const useRUIData = isFeatureEnabled('awbRUIData') || isFeatureEnabled('awbPremiumDemo');

  return useQuery<WrittenDirective[], Error>(
    ['written_directives', orgId, accreditationBodyId, versionId, standardId, jurisdictionId, useRUIData],
    () => fetchWrittenDirectives(orgId, accreditationBodyId, versionId, standardId, jurisdictionId, useRUIData),
    {
      staleTime: 900000, // 15 minutes in milliseconds
      ...options,
    }
  );
}
